module.exports = __webpack_public_path__ + "static/media/chat.71d0c2b7.svg";